export type WebinarCtaState = 'booked' | 'soldOut' | 'bookable'

export type WebinarCtaInput = {
    isBooked: boolean
    freePlaces: number
}

export const resolveWebinarCtaState = ({
    isBooked,
    freePlaces,
}: WebinarCtaInput): WebinarCtaState => {
    if (isBooked) return 'booked'
    if (freePlaces <= 0) return 'soldOut'
    return 'bookable'
}
